import { types as t } from 'mobx-state-tree';

const TVChanelItem = t.model('TVChanelItem', {
    Name: t.string,
});

export default TVChanelItem;
